import React from "react";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./shared/components/ScrollToTop";

import SignupPage from "./pages/SignupPage";

import LoginPage from "./pages/LoginPage";

import NotFoundPage from "./pages/NotFoundPage";

import ForgotPasswordPage from "./pages/ForgotPasswordPage";

import ResetPasswordPage from "./pages/ResetPasswordPage";

import ClientDashboardLayout from "./client/dashboard/layouts/ClientDashboardLayout";

import ClientPlatformsPage from "./client/dashboard/pages/ClientPlatformsPage";

import ClientReviewHubPage from "./client/dashboard/pages/ClientReviewHubPage";

import RedirectReviewInbox from "./client/dashboard/pages/RedirectReviewInbox";

import RedirectReviewAttention from "./client/dashboard/pages/RedirectReviewAttention";

import ClientHomePage from "./client/dashboard/pages/ClientHomePage";

import ClientBillingPage from "./client/dashboard/pages/ClientBillingPage";

import ClientDiscountsPage from "./client/dashboard/pages/ClientDiscountsPage";

import ClientOnboardingPage from "./client/dashboard/pages/ClientOnboardingPage";

import ClientEmailAlertsPage from "./client/dashboard/pages/ClientEmailAlertsPage";

import ClientSettingsPage from "./client/dashboard/pages/ClientSettingsPage";

import ClientSupportPage from "./client/dashboard/pages/ClientSupportPage";

import ClientTeamPage from "./client/dashboard/pages/ClientTeamPage";

import ClientDocumentationPage from "./client/dashboard/pages/ClientDocumentationPage";

import ClientDeletionCasesPage from "./client/dashboard/pages/ClientDeletionCasesPage";

import ClientPaymentPage from "./client/dashboard/pages/ClientPaymentPage";

import AdminDashboardLayout from "./admin/dashboard/layouts/AdminDashboardLayout";

import AdminDashboardHome from "./admin/dashboard/pages/AdminDashboardHome";

import AdminDeletionCasesPage from "./admin/dashboard/pages/AdminDeletionCasesPage";

import AdminUsersPage from "./admin/dashboard/pages/AdminUsersPage";

import AdminDocumentationPage from "./admin/dashboard/pages/AdminDocumentationPage";

import AdminEmailAlertsPage from "./admin/dashboard/pages/AdminEmailAlertsPage";

import AdminSupportTicketsPage from "./admin/dashboard/pages/AdminSupportTicketsPage";

import AdminSettingsPage from "./admin/dashboard/pages/AdminSettingsPage";

import AdminUserDetailPage from "./admin/dashboard/pages/AdminUserDetailPage";

import AdminCustomOffersPage from "./admin/dashboard/pages/AdminCustomOffersPage";

import RoleGuard from "./auth/components/RoleGuard";

import GuestGuard from "./auth/components/GuestGuard";

const App = () => {

  return (

    <BrowserRouter>

      <ScrollToTop />

      <Routes>

        {/* Guest-only: an authenticated user is redirected to their dashboard. */}
        <Route element={<GuestGuard />}>
          <Route path="/" element={<SignupPage />} />
          <Route path="/anmelden" element={<LoginPage />} />
        </Route>

        {/* Dual-use: reachable both when logged out (reset) and logged in
            (Settings → change password). Their internal links are auth-aware. */}
        <Route path="/passwort-vergessen" element={<ForgotPasswordPage />} />
        <Route path="/passwort-zuruecksetzen/:uid/:token" element={<ResetPasswordPage />} />



        <Route element={<RoleGuard requiredRole="client" />}>

          <Route path="/dashboard/client" element={<ClientDashboardLayout />}>

            <Route index element={<ClientHomePage />} />

            <Route path="onboarding" element={<ClientOnboardingPage />} />

            <Route path="billing" element={<ClientBillingPage />} />

            <Route path="discounts" element={<ClientDiscountsPage />} />

            <Route path="platforms" element={<ClientPlatformsPage />} />

            <Route path="reviews" element={<ClientReviewHubPage />} />

            <Route path="inbox" element={<RedirectReviewInbox />} />

            <Route path="attention" element={<RedirectReviewAttention />} />

            <Route path="deletion-cases" element={<ClientDeletionCasesPage />} />

            <Route path="payment" element={<ClientPaymentPage />} />

            <Route path="email-alerts" element={<ClientEmailAlertsPage />} />

            <Route path="team" element={<ClientTeamPage />} />

            <Route path="settings" element={<ClientSettingsPage />} />

            <Route path="support" element={<ClientSupportPage />} />

            <Route path="documentation" element={<ClientDocumentationPage />} />

          </Route>

        </Route>



        <Route element={<RoleGuard requiredRole="admin" />}>

          <Route path="/dashboard/admin" element={<AdminDashboardLayout />}>

            <Route index element={<AdminDashboardHome />} />

            <Route path="users" element={<AdminUsersPage />} />

            <Route path="users/:userId" element={<AdminUserDetailPage />} />

            <Route path="deletion-cases" element={<AdminDeletionCasesPage />} />

            <Route path="email-alerts" element={<AdminEmailAlertsPage />} />

            <Route path="support-tickets" element={<AdminSupportTicketsPage />} />

            <Route path="custom-offers" element={<AdminCustomOffersPage />} />

            <Route path="settings" element={<AdminSettingsPage />} />

            <Route path="documentation" element={<AdminDocumentationPage />} />

          </Route>

        </Route>



        <Route path="/dashboard" element={<Navigate to="/dashboard/client" replace />} />



        <Route path="*" element={<NotFoundPage />} />

      </Routes>

    </BrowserRouter>

  );

};



export default App;


